import type { GQL_ID } from '@@partner:types:graphql'

import React from 'react'
import { mergeLeft } from 'merge-left-utils'
import { useProductSearchFilters } from '../ProductSearchContext'

import ProductSearchCategoryFilter from './ProductSearchCategoryFilter'
import ProductSearchSaledFilter from './ProductSearchSaledFilter'
import ProductSearchPriceFilter from './ProductSearchPriceFilter'

import './ProductSearchFilters.scss'

export interface ProductSearchFiltersProps {
  shop_id: GQL_ID
  onChange?: (newFilters: any) => void
}

export default function ProductSearchFilters ({
  shop_id,
  onChange
}: ProductSearchFiltersProps) {
  const { filterQuery, setFilterQuery } = useProductSearchFilters()
  const handleFilterChange = (filter: string) => (data: any) => {
    const newFilters = mergeLeft(filterQuery, { [filter]: data })
    setFilterQuery(newFilters)
    onChange?.(newFilters)
  }

  return (
    <div className="ProductSearchFilters">
      <div className="ProductSearchFilters__Container">
        <div className="ProductSearchFilters__List">
          <div className="ProductSearchFilters__Filter ProductSearchFilters__Category">
            <label
              className="ProductSearchFilters__FilterName"
              htmlFor="ProductSearchFilters__Category"
            >
              категория
            </label>
            <ProductSearchCategoryFilter
              id="ProductSearchFilters__Category"
              shop_id={shop_id}
              onChange={handleFilterChange('category_id')}
              value={filterQuery.category_id}
            />
          </div>

          <div className="ProductSearchFilters__Filter ProductSearchResult__Saled">
            <label
              className="ProductSearchFilters__FilterName"
              htmlFor="ProductSearchFilters__SaledOnly"
            >
              только со скидками
            </label>
            <ProductSearchSaledFilter
              id="ProductSearchFilters__SaledOnly"
              onChange={handleFilterChange('saledOnly')}
              value={filterQuery.saledOnly}
            />
          </div>

          <div className="ProductSearchFilters__Filter ProductSearchResult__Price">
            <label
              className="ProductSearchFilters__FilterName"
              htmlFor="ProductSearchFilters__Price"
            >
              цена
            </label>
            <ProductSearchPriceFilter
              onChange={handleFilterChange('price')}
              value={filterQuery.price}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
